export default new (class ErrorsHelper {
  constructor() {
    this.isDevMode = process.env.NODE_ENV === "development";
  }
  unableToLoadLibrary(type, path, willIgnore = true) {
    this.warn(`[AmrPortal warn]: I wasn't able to load ${type} from ${path}.
    ${willIgnore ? "The module will be ignored." : ""}`);
  }
  buildInfoNotFound(module) {
    this
      .warn(`[AmrPortal warn]: I wasn't able to load "build-info.js" for module ${module.moduleName}.
    We use build-info.js to get the latest build of the module and force the browser to update libraries when the build version change.
    The module will not be updated until:
        - The user delete browser cache.
        - You add the build-info.js into your dist folder.
        - The browser decide to refresh the cache after expiration.`);
  }
  buildVersionNotFound(moduleName) {
    this
      .warn(`[AmrPortal warn]: Someone forgot to replace build version variable for ${moduleName}.
    We use the build version to manage browser caching otherwise your application will never be updated.
    Expected a version to be present in window object but found the placeholder "$VUE_APP_BUILD_VERSION"
    Please think to replace "$VUE_APP_BUILD_VERSION" with the current build version in "build-info.js"`);
  }
  menuItemIgnored(menuItem) {
    this
      .warn(`[AmrPortal warn]: The following menu item will be ignored since that it doesn't have a corresponding route declared in the slave application:
      Concerned Module: "${menuItem.moduleName}"
      Concerned route: "${menuItem.href}"
      Routes that you use in your menu should be declared in your router except routes with empty string as href.
    `);
  }
  UnkownCategoryCode(menuItem, Categories) {
    this.warn(`[AmrPortal]: Unknown category code "${
      menuItem.category.code
    }" in the menu item "${menuItem.title}".
              Allowed categories: ${Categories.join(" - ")}
          `);
  }
  UserCannotAccessModule(moduleName, userName) {
    this
      .warn(`[AmrPortal warn]: The module  ${moduleName} will not be loaded because "${userName}" does not have access to it.
    If you want ${userName} to access ${moduleName} you should add the role "${moduleName}-access" to the concerned user.
    `);
  }
  MissingModuleBaseUrl(moduleName, url) {
    this
      .warn(`[AmrPortal warn]: The module  ${moduleName} will be ignored because I didn't find a valid URL for librairies.
    Did you forget to replace placeholder variable with the URL to the module librairies ?
    Expected: A valid URL to the librairies of ${moduleName}.
    Found: A placeholder variable that wasn't replaced : "${url}"`);
  }
  UnknownRouteFromSearchResult(route) {
    this
      .warn(`[AmrPortal warn]: The route '${route}' provided as a search result is unkown by AmrPortal.
    Please provide a valid route name that exists in your child app and make sure that all your routes names are unique.`);
  }
  warn(msg) {
    if (this.isDevMode) console.warn(msg);
  }
})();
